import { SUPPORT_GROUP, ADMINS } from "../../config/roleConfig";

export function isSupportGroup(role, subrole) {
  try {
    return ADMINS.includes(role) && SUPPORT_GROUP.includes(subrole);
  } catch (e) {
    return false;
  }
}
